import { Provider } from '@angular/core';
import { DEVICE_ID_COOKIE_DOMAIN } from './device-id-cookie-domain.token';
import { DeviceIdentificationService } from './device-identification.service';

export function provideDeviceIdentification(cookieDomain?: string): Provider[] {
  return [DeviceIdentificationService, { provide: DEVICE_ID_COOKIE_DOMAIN, useValue: cookieDomain }];
}
